import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class ChatNotificationService {
  private chatsWithNewMessage: { [conversationId: string]: boolean } = {};
  private _newMessageMap$ = new BehaviorSubject<{ [conversationId: string]: boolean }>({});
  
  // Debouncing mechanism to prevent spam
  private updateTimeouts: { [conversationId: string]: any } = {};
  private readonly UPDATE_DEBOUNCE_TIME = 1000; // 1 second debounce

  setNewMessage(conversationId: string) {
    // Clear any existing timeout for this conversation
    if (this.updateTimeouts[conversationId]) {
      clearTimeout(this.updateTimeouts[conversationId]);
    }

    // Set the flag immediately for UI responsiveness
    this.chatsWithNewMessage[conversationId] = true;

    // Debounce the observable emission to prevent excessive updates
    this.updateTimeouts[conversationId] = setTimeout(() => {
      this._newMessageMap$.next({...this.chatsWithNewMessage});
      delete this.updateTimeouts[conversationId];
    }, this.UPDATE_DEBOUNCE_TIME);
  }

  clearNewMessage(conversationId: string) {
    // Clear any pending timeout
    if (this.updateTimeouts[conversationId]) {
      clearTimeout(this.updateTimeouts[conversationId]);
      delete this.updateTimeouts[conversationId];
    }

    if (this.chatsWithNewMessage[conversationId]) {
      delete this.chatsWithNewMessage[conversationId];
      this._newMessageMap$.next({...this.chatsWithNewMessage});
    }
  }

  getNewMessageMap$() {
    return this._newMessageMap$.asObservable();
  }

  // Method to check if a conversation has new messages without triggering updates
  hasNewMessage(conversationId: string): boolean {
    return !!this.chatsWithNewMessage[conversationId];
  }

  // Clean up method for component destruction
  cleanup() {
    Object.keys(this.updateTimeouts).forEach(conversationId => {
      clearTimeout(this.updateTimeouts[conversationId]);
    });
    this.updateTimeouts = {};
  }
}
